// Stable radio tokens so selection state never depends on address object
// identity or shape.
export const USER_ENTERED_VALUE = 'user-entered';
export const SUGGESTED_VALUE_PREFIX = 'suggested-';

export const suggestionValue = index => `${SUGGESTED_VALUE_PREFIX}${index}`;
